import { AppBottomTableMobileComponent } from './../app-bottom-table-mobile/app-bottom-table-mobile.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CartProductService } from './../../../../api/cartProduct.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Component, OnInit, ChangeDetectorRef, ViewChild, Output, ElementRef } from '@angular/core';
import { DocumentService } from '@app/api/api';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import moment from 'moment';
import Konva from 'konva';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { LocationStrategy, PlatformLocation } from '@angular/common';
import { UtilService } from '@app/services/util.service';
import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
@Component({
  selector: 'meu-search-by-doc-page',
  templateUrl: './search-by-doc-page.component.html',
  styleUrls: ['./search-by-doc-page.component.scss']
})
export class SearchByDocPageComponent implements OnInit {
  //   @ViewChild('chooseFile', { static: false }) chooseFile: ElementRef;
  //   @Output() onChangeData = new EventEmitter();
  mobileQuery: MediaQueryList;
  tabletQuery: MediaQueryList;
  constructor(
    private documentService: DocumentService,
    private ref: ChangeDetectorRef,
    private route: ActivatedRoute,
    private cartProductService: CartProductService,
    private toastr: ToastrService,
    private location: PlatformLocation,
    private router: Router,
  private bottomSheet: MatBottomSheet,
  private translate: TranslateService,
    media: MediaMatcher,
  ) {
    router.events
      .subscribe((event: NavigationStart) => {
        var _this = this;
        if (event.navigationTrigger === 'popstate') {

          setTimeout(function () {
            if (_this.route.snapshot.params.id != null && _this.route.snapshot.params.id !== "" && _this.route.snapshot.params.id !== undefined) {
              _this.documentId = _this.route.snapshot.params.id;
              _this.getDocumentById();
            }
          }, 250);
        }
      });
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.tabletQuery = media.matchMedia(
      '(max-width: 1024px) and (min-width: 600px)'
    );
  }

  image: any = null;
  colEl: any;

  lstCategoryRoot: any = [];
  lstCategory: any = [];
  host: any;
  filter: any = "";
  lstAllSubDoc: any = [];
  pageSize = 10;
  pageIndex = 1;
  arrRootTemp = [];
  isShowLstCategory: boolean = false;
  //konva
  width = window.innerWidth;
  height = window.innerHeight;
  layer: Konva.Layer;
  stage: Konva.Stage;
  newScale = 1;
  pointStage = { x: 1, y: 1 };
  isRenderLine: boolean = false;
  penMenu: any;
  lstPointLine: any = [];
  lstLineDraff: any = [];
  rectangleMenu: any;
  lstRectangle: any = [];
  lstTranform: any = [];
  listGroupMenu: any = [];
  circleMenu: any;
  imageMenu: any;
  selectedID: any;
  documentId: any;
  lstDocumentShape: any = [];
  lstProductShape: any = [];
  displayedColumns: string[] = ['index', 'name', 'code'];
  document: any = { data: null, shapes: null };
  nameDocument: any = "";
  lstShapes: any = [];
  lstShapesData: any = [];
  shapeSelected: any = "";
  imageServer: any = [];
  theImg: Konva.Image;
  selectedShapeId: any;
  selectedShapeIdHover: any;
  mouseHover: boolean = false;
  //End konva
  ngOnInit() {
    // konva
    this.width = document.getElementById("containerKonva").offsetWidth;
    this.height = 500;
    this.layer = new Konva.Layer();
    this.stage = new Konva.Stage({
      container: 'containerKonva',
      width: this.width,
      height: this.height,
      draggable: true,
    });
    //var layer = new Konva.Layer();
    this.stage.add(this.layer);
    var scaleBy = 1.1;
    this.stage.on('wheel', e => {
      e.evt.preventDefault();
      var oldScale = this.stage.scaleX();
      var mousePointTo = {
        x: this.stage.getPointerPosition().x / oldScale - this.stage.x() / oldScale,
        y: this.stage.getPointerPosition().y / oldScale - this.stage.y() / oldScale
      };
      this.newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;
      if (this.newScale < 0.1) this.newScale = 0.1;
      if (this.newScale > 1.8) this.newScale = 1.8;
      this.stage.scale({ x: this.newScale, y: this.newScale });
      this.pointStage = {
        x:
          -(mousePointTo.x - this.stage.getPointerPosition().x / this.newScale) *
          this.newScale,
        y:
          -(mousePointTo.y - this.stage.getPointerPosition().y / this.newScale) *
          this.newScale
      };
      //this.reRenderMenu(this.pointStage, this.newScale)
      this.stage.position(this.pointStage);
      this.stage.draw();
    });
    if (this.route.snapshot.params.id != null && this.route.snapshot.params.id !== "" && this.route.snapshot.params.id !== undefined) {
      this.documentId = this.route.snapshot.params.id;
      this.getDocumentById();
    }
  }
  ngOnDestroy() {
    this.ref.detach();
  }
  public keyUp = new Subject<KeyboardEvent>();
  //konva funtion
  scrollMatable(elementID) {

    const rowElement = document.getElementById(elementID);
    if (rowElement != undefined && rowElement != null) {
      setTimeout(function () {
        document.getElementById(elementID).scrollIntoView(false);
      }, 0.5);
    }


  }
  openBottomSheet(shpaeId): void {
    var lstShapeRefs = this.lstShapes.find(x => x.data.id == shpaeId).shapeRefs;
    this.bottomSheet.open(AppBottomTableMobileComponent, {
      data: lstShapeRefs
    });
  }
  renderRectagle(id, uni_id, x, y, rotation, scaleX, scaleY, shapeRefs) {
    var list;
    var remove;
    let _this = this;
    const localDate = new Date();
    let unique_id = uni_id != null ? uni_id : moment.utc(localDate).valueOf();
    this.selectedID = unique_id;
    var group = new Konva.Group({
      x: x,
      y: y,
      // width: 100,
      // height: 50,
      rotation: 0,
      draggable: false,

    });
    group.moveToTop();

    var rect = new Konva.Rect({
      id: unique_id,
      x: 0,
      y: 0,
      width: 100,
      height: 50,
      stroke: '#f4d21b',
      fill: '#f4d21b',
      strokeWidth: 2,
      draggable: false,
      rotation: rotation,
      opacity: 0.3,
      scaleX: scaleX,
      scaleY: scaleY,
    });
    rect.on('mouseover', function () {
      _this.mouseHover = true;
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);

      if (_this.selectedShapeId == null) {
        _this.scrollMatable(_this.lstShapes[indexRect].data.id);
        _this.selectedShapeIdHover = _this.lstShapes[indexRect].data.id;
      }
      _this.ref.detectChanges();
      let idChoose = null;
      if (_this.selectedShapeId != null) {
        idChoose = _this.lstShapes.find(x => x.data.id == _this.selectedShapeId).data.unique_id;
      }
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id || idChoose == _this.lstRectangle[i].shape.id()) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.layer.draw();
    });
    rect.on('mousedown', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      if (_this.selectedShapeId == _this.lstShapes[indexRect].data.id) {
        _this.selectedShapeId = null;
      }
      else {
        _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
        _this.scrollMatable(_this.lstShapes[indexRect].data.id);

      }
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id && _this.selectedShapeId != null) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();

      if (_this.mobileQuery.matches) {
        _this.openBottomSheet(_this.lstShapes[indexRect].data.id);
      }
    })
    rect.on('mouseout', function () {
      _this.selectedShapeIdHover = null
    })

    rect.on('touchstart', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
      _this.scrollMatable(_this.lstShapes[indexRect].data.id);

      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();

    });
    rect.on('touchend', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.layer.draw();
      if (_this.mobileQuery.matches) {
        _this.openBottomSheet(_this.lstShapes[indexRect].data.id);
      }
    });
    group.add(rect);
    group.moveToTop();
    this.layer.add(group);
    this.layer.draw();
    this.lstRectangle.push({
      data: {
        id: id,
        center: { x: group.x(), y: group.y() },
        document_id: this.documentId,
        height: null,
        radius: null,
        rotation: rect.rotation(),
        scaleX: rect.scaleX(),
        scaleY: rect.scaleY(),
        type: "rectangle",
        width: null,
        unique_id: unique_id,
      },
      shape: rect,
      shapeRefs: shapeRefs
    }
    );
  }
  renderCircle(id, uni_id, x, y, rotation, scaleX, scaleY, shapeRefs) {
    const localDate = new Date();
    var list;
    var remove;
    var _this = this;
    let unique_id = uni_id != null ? uni_id : moment.utc(localDate).valueOf();
    var group = new Konva.Group({
      x: x,
      y: y,
      // width: 100,
      // height: 50,
      rotation: 0,
      draggable: false,
    });
    group.moveToTop();
    var circle = new Konva.Circle({
      id: unique_id,
      x: 0,
      y: 0,
      radius: 50,
      stroke: '#f4d21b',
      fill: '#f4d21b',
      strokeWidth: 2,
      draggable: false,
      opacity: 0.3,
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: rotation
    });
    group.add(circle);
    circle.on('mouseover', function () {
      _this.mouseHover = true;
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);

      if (_this.selectedShapeId == null) {
        _this.scrollMatable(_this.lstShapes[indexRect].data.id);
        _this.selectedShapeIdHover = _this.lstShapes[indexRect].data.id;
      }
      _this.ref.detectChanges();
      let idChoose = null;
      if (_this.selectedShapeId != null) {
        idChoose = _this.lstShapes.find(x => x.data.id == _this.selectedShapeId).data.unique_id;
      }
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id || idChoose == _this.lstRectangle[i].shape.id()) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.layer.draw();
    });
    circle.on('mousedown', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      if (_this.selectedShapeId == _this.lstShapes[indexRect].data.id) {
        _this.selectedShapeId = null;

      }
      else {
        _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
        _this.scrollMatable(_this.lstShapes[indexRect].data.id);

      }
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id && _this.selectedShapeId != null) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();

      if (_this.mobileQuery.matches) {
        _this.openBottomSheet(_this.lstShapes[indexRect].data.id);
      }
    })
    circle.on('mouseout', function () {
      _this.selectedShapeIdHover = null
    })

    circle.on('touchstart', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
      _this.scrollMatable(_this.lstShapes[indexRect].data.id);

      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();

    });
    circle.on('touchend', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();
      if (_this.mobileQuery.matches) {
        _this.openBottomSheet(_this.lstShapes[indexRect].data.id);
      }
    });
    this.layer.add(group);
    this.layer.draw();
    this.lstRectangle.push({
      data:
      {
        id: id,
        center: { x: group.x(), y: group.y() },
        document_id: this.documentId,
        height: null,
        radius: null,
        rotation: circle.rotation(),
        scaleX: circle.scaleX(),
        scaleY: circle.scaleY(),
        type: "circle",
        width: null,
        unique_id: unique_id,
      },
      shape: circle
      , shapeRefs: shapeRefs
    });
  }
  renderImageserver(urlServer) {
    var _this = this;
    var img = new Image();
    img.src = urlServer;
    if (this.theImg != null) {
      this.theImg.destroy();
      _this.layer.draw();
    }
    this.theImg = new Konva.Image({
      image: img,
      x: 50,
      y: 0,
      // width: auto,
      // height: this.height,
      draggable: false,
    });

    setTimeout(function () {
      _this.theImg.moveToBottom();
      _this.layer.add(_this.theImg);
      _this.layer.draw();
    }, 200);


  }
  renderRegularPolygon(id, uni_id, list_points, shapeRefs) {
    var list;
    var remove;
    const localDate = new Date();
    let unique_id = uni_id != null ? uni_id : moment.utc(localDate).valueOf();
    let _this = this;
    let lst_point_draft = [];
    for (let i = 0; i < list_points.length; i++) {
      lst_point_draft.push(list_points[i].x);
      lst_point_draft.push(list_points[i].y);
    }
    var poly = new Konva.Line({
      id: unique_id,
      points: lst_point_draft,
      stroke: '#f4d21b',
      fill: '#f4d21b',
      strokeWidth: 2,
      draggable: false,
      opacity: 0.3,
      closed: true,
    });
    poly.on('mouseover', function () {
      _this.mouseHover = true;
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);

      if (_this.selectedShapeId == null) {
        _this.scrollMatable(_this.lstShapes[indexRect].data.id);
        _this.selectedShapeIdHover = _this.lstShapes[indexRect].data.id;
      }
      _this.ref.detectChanges();
      let idChoose = null;
      if (_this.selectedShapeId != null) {
        idChoose = _this.lstShapes.find(x => x.data.id == _this.selectedShapeId).data.unique_id;
      }
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id || idChoose == _this.lstRectangle[i].shape.id()) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.layer.draw();
    });
    poly.on('mousedown', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      if (_this.selectedShapeId == _this.lstShapes[indexRect].data.id) {
        _this.selectedShapeId = null;

      }
      else {
        _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
        _this.scrollMatable(_this.lstShapes[indexRect].data.id);

      }
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id && _this.selectedShapeId != null) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();

      if (_this.mobileQuery.matches) {
        _this.openBottomSheet(_this.lstShapes[indexRect].data.id);
      }
    })
    poly.on('mouseout', function () {
      _this.selectedShapeIdHover = null
    })

    poly.on('touchstart', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
      _this.scrollMatable(_this.lstShapes[indexRect].data.id);

      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();

    });
    poly.on('touchend', function () {
      let indexRect = _this.lstShapes.findIndex(x => x.data.unique_id == unique_id);
      _this.selectedShapeId = _this.lstShapes[indexRect].data.id;
      for (let i = 0; i < _this.lstRectangle.length; i++) {
        if (_this.lstRectangle[i].shape.id() == unique_id) {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.5);
        }
        else {
          _this.lstRectangle[i].shape.setAttr('opacity', 0.3);
        }
      }
      _this.ref.detectChanges();
      if (_this.mobileQuery.matches) {
        _this.openBottomSheet(_this.lstShapes[indexRect].data.id);
      }
    });
    this.layer.add(poly)
    this.layer.draw();
    this.lstRectangle.push({
      data: {
        id: id,
        center: list_points[0],
        document_id: this.documentId,
        height: null,
        radius: null,
        polygon_points: list_points,
        type: "polygon",
        width: null,
        unique_id: unique_id
      }
      ,
      shape: poly,
      shapeRefs: shapeRefs

    });
  }
  renderTableDocumentProduct(shapeRefs) {
    for (let i = 0; i < shapeRefs.length; i++) {
      if (shapeRefs[i].product_id != null) {
        shapeRefs[i].seo_name = UtilService.slugify(shapeRefs[i].extend_product_name);
      }
      this.lstDocumentShape.push(shapeRefs[i])
    }
    // for (let i = 0; i < this.lstProductShape.length; i++) {
    //   this.lstProductShape[i].seo_name = UtilService.slugify(this.lstProductShape[i].extend_product_name);// this.lstProductSearch[i].name.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
    // }
    this.lstDocumentShape = this.lstDocumentShape.slice();
    this.ref.detectChanges();
  }
  getDocumentById() {
    this.lstShapes = [];
    this.lstRectangle = [];
    this.lstDocumentShape = [];
    this.lstProductShape = [];
    var _this = this;
    this.documentService.apiDocumentsIdDataGet(this.documentId).subscribe(res => {
      if (res.success) {
        this.document = res.data;
        this.nameDocument = res.data.data.name
        this.lstShapes = res.data.shapes;
        this.imageServer = res.data.data.image
        if (this.document.data.image != null) {
          this.renderImageserver(environment.backendhost + this.document.data.image);
        }
        if (this.lstShapes.length > 0) {
          setTimeout(function () {
            _this.getDataServer(_this.lstShapes);
          }, 200);

        }
        //this.drawimage.renderImageserver(environment.backendhost + this.document.image)
      }
    })
  }
  getDataServer(listDataShape) {
    for (let i = 0; i < listDataShape.length; i++) {
      let dataServer = listDataShape[i].data;
      if (listDataShape[i].shapeRefs.length > 0) {
        this.renderTableDocumentProduct(listDataShape[i].shapeRefs);
      }
      switch (dataServer.type) {
        case "rectangle":
          this.renderRectagle(dataServer.id, dataServer.unique_id, dataServer.center.x, dataServer.center.y, dataServer.rotation, dataServer.scaleX, dataServer.scaleY, listDataShape[i].shapeRefs);
          break;
        case "circle":
          this.renderCircle(dataServer.id, dataServer.unique_id, dataServer.center.x, dataServer.center.y, dataServer.rotation, dataServer.scaleX, dataServer.scaleY, listDataShape[i].shapeRefs);
          break;
        case "polygon":
          this.renderRegularPolygon(dataServer.id, dataServer.unique_id, dataServer.polygon_points, listDataShape[i].shapeRefs);
          break;
        default:
        // code block
      }
    }
    // this.renderTableDocumentProduct(this.lstRectangle[0].shapeRefs);

  }
  addCart(product_id) {
    this.cartProductService.apiMyCartProductsPost(product_id).subscribe(res => {
      if (res.success) {
        this.toastr.success(this.translate.instant('ECOMMERCE.PRODUCT.ADD_TO_CART_SUCCESS'));
      }
    })
  }
  selectProduct(productId, seoName) {
    this.router.navigate(['/product/' + productId + '/' + seoName + '/details']);
  }
  reloadComponent(id) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/searchbydocument/' + id + '/detail']);
  }
  //end konva

}
